export function stripTrailingSlashFromPathname(): void {
  const { pathname, search, hash } = window.location
  if (pathname.length > 1 && pathname.endsWith('/')) {
    window.history.replaceState(null, '', `${pathname.replace(/\/+$/, '')}${search}${hash}`)
  }
}
